'use strict'
import urls from '../Urls'
import axios from 'axios'

export const CHILD_API_ENDPOINTS = {
  MOBY_LIST: 'mobyList',
  YEARS_LIST: 'moby/years',
  MOBY_GET: 'moby/get',
  MOBY_SAVE: 'moby/save',
  MOBY_DELETE: 'moby/delete',
  MOBY_ADD: 'moby/add',
  ADDRESS_LIST: 'address/list',
  ADDRESS_SAVE: 'address/save',
  ADDRESS_REMOVE: 'address/remove',
  ELIG_LIST: 'elig/list',
  ELIG_SAVE: 'elig/save',
  ELIG_REMOVE: 'elig/remove',
  ACCRED_AGENCY_LIST: 'accred/agencyList',
  ACCRED_GET: 'accred/get',
  ACCRED_SAVE: 'accred/save',
  SIBLING_LIST: 'siblings',
  SIBLING_SAVE: 'siblings/save',
  SIBLING_REMOVE: 'siblings/remove'
}

// Moby End Points
function getMobyAdminEndPoint (orgId) {
  let paramStr = '?orgId=' + orgId

  return urls.memberOrgAdminController() + paramStr
}

function getMobyListEndPoint (orgId) {
  let paramStr = '?orgId=' + orgId

  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.MOBY_LIST + paramStr
}

function getOrgAcademicYearsEndPoint (orgId) {
  let paramStr = '?orgId=' + orgId

  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.YEARS_LIST + paramStr
}

function getMobyEndPoint (orgId, academicYear) {
  let paramStr = '?orgId=' + orgId + '&academicYear=' + academicYear

  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.MOBY_GET + paramStr
}

function saveMobyEndPoint () {
  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.MOBY_SAVE
}

function deleteMobyEndPoint () {
  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.MOBY_DELETE
}

function addMobyYearEndPoint () {
  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.MOBY_ADD
}

// Org Address End Points
function getAddressListEndPoint (orgId) {
  let paramStr = '?orgId=' + orgId

  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.ADDRESS_LIST + paramStr
}

function saveOrgAddressEndPoint () {
  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.ADDRESS_SAVE
}

function removeOrgAddressEndPoint () {
  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.ADDRESS_REMOVE
}

// Org Eligibility End Points
function getEligibilityListEndPoint (orgId) {
  let paramStr = '?orgId=' + orgId

  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.ELIG_LIST + paramStr
}

function saveOrgEligibilityEndPoint () {
  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.ELIG_SAVE
}

function removeOrgEligibilityEndPoint () {
  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.ELIG_REMOVE
}

function getAccredAgencyListEndPoint () {
  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.ACCRED_AGENCY_LIST
}

function saveSiblingEndPoint () {
  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.SIBLING_SAVE
}

function removeSiblingEndPoint (siblingId) {
  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.SIBLING_REMOVE + '?siblingId=' + siblingId
}

function getOrgSiblingsEndPoint (orgId) {
  let paramStr = '?orgId=' + orgId

  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.SIBLING_LIST + paramStr
}

function getOrgAccreditationData () {
  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.ACCRED_GET
}

function saveMoaEndPoint () {
  return urls.memberOrgAdminApiController() + '/' + CHILD_API_ENDPOINTS.ACCRED_SAVE
}

function loadOrgMobyYears (orgId) {
  return axios.get(getOrgAcademicYearsEndPoint(orgId))
}

function loadMoby (orgId, academicYear) {
  return axios.get(getMobyEndPoint(orgId, academicYear))
}

function saveMoby (data) {
  return axios.post(saveMobyEndPoint(), data)
}

function deleteOrgYear (data) {
  return axios.post(deleteMobyEndPoint(), data)
}

function addMobyYear (data) {
  return axios.post(addMobyYearEndPoint(), data)
}

function loadAccredAgencyList () {
  return axios.get(getAccredAgencyListEndPoint())
}

function saveMoa (data) {
  return axios.post(saveMoaEndPoint(), data)
}

function loadAccreditationData (orgId, academicYear) {
  let params = {
    params: {
      'orgId': orgId,
      'academicYear': academicYear
    }
  }

  return axios.get(getOrgAccreditationData(), params)
}

function loadAddresses (orgId) {
  return axios.get(getAddressListEndPoint(orgId))
}

function saveOrgSibling (data) {
  return axios.post(saveSiblingEndPoint(), data)
}

function removeOrgSibling (siblingId) {
  return axios.post(removeSiblingEndPoint(siblingId))
}

function loadOrgSiblings (orgId) {
  return axios.get(getOrgSiblingsEndPoint(orgId))
}

export default {
  getMobyListEndPoint: getMobyListEndPoint,
  getAddressListEndPoint: getAddressListEndPoint,
  saveOrgAddressEndPoint: saveOrgAddressEndPoint,
  removeOrgAddressEndPoint: removeOrgAddressEndPoint,
  getEligibilityListEndPoint: getEligibilityListEndPoint,
  saveOrgEligibilityEndPoint: saveOrgEligibilityEndPoint,
  removeOrgEligibilityEndPoint: removeOrgEligibilityEndPoint,
  loadOrgMobyYears: loadOrgMobyYears,
  loadMoby: loadMoby,
  saveMoby: saveMoby,
  deleteOrgYear: deleteOrgYear,
  getMobyAdminEndPoint: getMobyAdminEndPoint,
  addMobyYear: addMobyYear,
  loadAccredAgencyList: loadAccredAgencyList,
  loadAccreditationData: loadAccreditationData,
  saveMoa: saveMoa,
  loadAddresses: loadAddresses,
  saveOrgSibling: saveOrgSibling,
  removeOrgSibling: removeOrgSibling,
  loadOrgSiblings: loadOrgSiblings
}
